import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import FranciscoGiancarelli from "Developers/FranciscoGiancarelli";
import JuanBecchio from "Developers/JuanBecchio";
import LuisFernandoRamos from "Developers/LuisFernandoRamos";
import FranciscoGiancarelliProfilePicture from "ProfilePictures/FranciscoGiancarelli.jpeg";
import JuanBecchioProfilePicture from "ProfilePictures/JuanBecchio.jpg";
import LuisFernandoProfilePicture from "ProfilePictures/LuisFernandoRamos.jpg";
import JustoMedinaProfilePicture from "ProfilePictures/JustoMedina.jpeg";
import LautaroGSProfilePicture from "ProfilePictures/LautaroGS.png";
import JosueVitali from "Developers/JosueVitali";
import FedericoSn from "Developers/FedericoSn";
import FedericoSnProfilePicture from "ProfilePictures/FedericoSn.jpg";
import JustoMedina from "Developers/JustoMedina/JustoMedina";
import LautaroGS from "Developers/LautaroGS/LautaroGS";
import SebaPegoraroProfilePicture from "ProfilePictures/SebaPegoraro/SebaPegoraro.jpeg";
import ValentinGalfreProfilePicture from "ProfilePictures/ValentinGalfre.jpg";
import SebaPegoraro from "Developers/SebastianPegoraro";
import ValentinGalfre from "Developers/ValentinGalfre";
import JosueVitaliIMG from "ProfilePictures/Josue.png";
import LuiSanchez from "Developers/LuiSanchez";
import LuisSanchez from "ProfilePictures/LuisSanchez.jpg";
import AgustinGuerra from "Developers/AgustinGuerra";
import AgustinGuerraImg from "ProfilePictures/AgustinGuerra.jpeg";
import IgnacioMustafha from "ProfilePictures/IgnacioMustafha.jpeg";
import IgnacioMustafhaProfile from "Developers/IgnacioMustafha/IgnacioMustafha";
import EstebanCaccin from "Developers/EstebanCaccin/EstebanCaccin";
import EstebanCaccinImg from "ProfilePictures/EstebanCaccin/steve.jpg";

import homeStyles from "./Home.module.scss";

const Home: React.FC = () => {
  return (
    <Container>
      <h1>Bienvenido a Crombie DevTeam!</h1>
      <p>
        Actualmente estás visualizando{" "}
        <mark>
          <strong>crombie docs</strong>
        </mark>
        , un repositorio para que vos y todos los integrantes del equipo puedan
        consultar (y volcar) información sobre las personas, proyectos, y
        procesos en la empresa.
      </p>
      <div className='d-flex flex-row flex-wrap'>
        <Link to={"/developer/" + FranciscoGiancarelli.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de perfil de Francisco Giancarelli'
            height={72}
            src={FranciscoGiancarelliProfilePicture}
          />
        </Link>
        <Link to={"/developer/" + JuanBecchio.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de perfil de Juan Becchio'
            height={72}
            src={JuanBecchioProfilePicture}
          />
        </Link>
        <Link to={"/developer/" + LuisFernandoRamos.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de perfil de Luis Fernando Ramos'
            height={72}
            src={LuisFernandoProfilePicture}
          />
        </Link>
        <Link to={"/developer/" + JosueVitali.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de perfil de Luis Fernando Ramos'
            height={72}
            src={JosueVitaliIMG}
          />
        </Link>
        <Link to={"/developer/" + FedericoSn.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de perfil de Federico Estañoli'
            height={72}
            src={FedericoSnProfilePicture}
          />
        </Link>
        <Link to={"/developer/" + JustoMedina.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de perfil de Justo Medina'
            height={72}
            src={JustoMedinaProfilePicture}
          />
        </Link>
        <Link to={"/developer/" + LautaroGS.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de perfil de Lautaro G.S.'
            height={72}
            src={LautaroGSProfilePicture}
          />
        </Link>
        <Link to={"/developer/" + SebaPegoraro.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de perfil de Seba Pegoraro'
            height={72}
            src={SebaPegoraroProfilePicture}
          />
        </Link>
        <Link to={"/developer/" + ValentinGalfre.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de perfil de Seba Pegoraro'
            height={72}
            src={ValentinGalfreProfilePicture}
          />
        </Link>
        <Link to={"/developer/" + LuiSanchez.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de Perfil de Luis Sanchez'
            height={72}
            src={LuisSanchez}
          />
        </Link>
        <Link to={"/developer/" + AgustinGuerra.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de Perfil de Luis Sanchez'
            height={72}
            src={AgustinGuerraImg}
          />
        </Link>

        <Link to={`/developer/${EstebanCaccin.route}`}>
          <img
            className={`rounded-circle mr-5 mb-5 ${homeStyles.estebanCaccin}`}
            width={72}
            alt='Foto de Perfil de Steve'
            height={72}
            src={EstebanCaccinImg}
          />
        </Link>
        <Link to={"/developer/" + IgnacioMustafhaProfile.route}>
          <img
            className='rounded-circle mr-5 mb-5'
            width={72}
            alt='Foto de Perfil de Luis Sanchez'
            height={72}
            src={IgnacioMustafha}
          />
        </Link>
      </div>
    </Container>
  );
};

export default Home;
